<template>
<div>

    <Drawer :mask-closable="false" @on-close="handleReset('companyForm')" class="demo-drawer-prime"
            title="Edit Company"
            v-model="$parent.updateCompanyDrawer" width="620">
        <Row>
            <Col style="padding-top: 10px">
                <Form :model="companyForm" :rules="companyRuleValidate" label-position="top" ref="companyForm">
                    <Card shadow title="Company Detail">
                      <template slot="extra">
                        <FormItem prop="isApproved">
                          <i-switch v-model="companyForm.isApproved" title="Status" :style="companyForm.isApproved?'background: green':'background: red'"/>
                        </FormItem>
                      </template>
                      <FormItem label="I am a" prop="userType">
                            <ApolloQuery :query="query_GET_COMPANY_TYPE" :skip="companyType_skip">
                                <template slot-scope="{ result: { loading, error, data } }">
                                    <div v-if="loading"> Loading...</div>
                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                    <div v-else-if="data">
                                        <div style="display: none;"></div>
                                        <Select v-model="companyForm.userType">
                                            <template v-for="companyType in data.type">
                                                <OptionGroup :label="companyType.name" v-if="companyType.parentId===null">
                                                    <Option :key="index" :value="companyTypeTemp.id"
                                                            v-for="(companyTypeTemp,index) in data.type"
                                                            v-if="companyTypeTemp.type===companyType.type">{{ companyTypeTemp.name }}
                                                    </Option>
                                                </OptionGroup>
                                            </template>
                                        </Select>
                                    </div>
                                    <div v-else>
                                        There are no Companies Available yet.
                                    </div>
                                </template>
                            </ApolloQuery>
                      </FormItem>
                        <Row :gutter="32">
                            <Col span="12">
                                <FormItem label="Company Name" prop="name">
                                    <Input placeholder="Enter your Company" v-model="companyForm.name"></Input>
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="Registered Email" prop="email">
                                    <Input placeholder="Search Email" v-model="companyForm.email"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row :gutter="32">
                            <Col span="12">
                                <FormItem label="Mobile" prop="mobile">
                                    <Input :maxlength="10" number placeholder="Enter your Mobile"
                                           v-model="companyForm.mobile"></Input>
                                </FormItem>
                            </Col>
                            <Col span="12">
                                <FormItem label="GSTIN" prop="gstin">
                                    <Input :maxlength="15" class="capitalize-gstin" placeholder="Enter your GSTIN"
                                           v-model="companyForm.gstin"></Input>
                                </FormItem>
                            </Col>
                        </Row>
                        <Divider></Divider>
                        <!-- -------------------- CompanyUsers section ------------------- -->
                        <Row>
                          <h3>Company Users
                            <Button @click="addCompanyUserDrawer=true" icon="ios-add" shape="circle" type="primary"></Button>
                          </h3>
                        </Row>
                        <Divider></Divider>
                        <Row v-if="companyUsers.length">
                          <Col :key="index" span="24" v-for="(user, index) in companyUsers">
                            <Card>
                              <p slot="title">User {{index+1}}
                                <Icon style="float: right" type="md-close" @click.stop="removeCompanyUser(index)"></Icon>
                                <Icon style="float: right;margin-right: 5px" type="md-create" @click.stop="onEditCompanyUser(user, index)"></Icon></p>
                              <Row>
<!--                                <Col span="10">Role</Col>-->
<!--                                <Col span="14">{{user.role == 1 ? 'Marketing' : 'Dispatch'}}</Col>-->
                                <Col span="10">Name</Col>
                                <Col span="14">{{user.name}}</Col>
                                <Col span="10">Mobile</Col>
                                <Col span="14">{{user.mobile}}</Col>
                                <Col span="10">Email</Col>
                                <Col span="14">{{user.email}}</Col>
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                        <Row v-else>No Company Users added yet</Row>
                        <!-- ------x-------x-------x-------x-------x--------x-------- -->
                        <Divider></Divider>
                        <!-- -------------------- Addresses section ------------------- -->
                        <Row>
                            <h3>Addresses
                                <Button @click="addAddressDrawer=true" icon="ios-add" shape="circle" type="primary"></Button>
                            </h3>
                        </Row>
                        <Divider></Divider>
                        <Row v-if="addressArr.length">
                            <Col :key="index" span="24" v-for="(address, index) in addressArr">
                                <Card>
                                    <p slot="title">Address {{index+1}}
                                        <Icon style="float: right" type="md-close" @click.stop="removeAddress(index)"></Icon>
                                        <Icon style="float: right;margin-right: 5px" type="md-create" @click.stop="onEditAddress(address, index)"></Icon></p>
                                    <p>{{getAddressString(address)}}</p>
                                </Card>
                            </Col>
                        </Row>
                        <Row v-else>No Address added yet</Row>
                        <!-- ------x-------x-------x-------x-------x--------x-------- -->
                        <Divider></Divider>
                        <!-- -------------------- Contacts section ------------------- -->
                        <Row>
                            <h3>Contacts
                                <Button @click="addContactDrawer=true" icon="ios-add" shape="circle" type="primary"></Button>
                            </h3>
                        </Row>
                        <Divider></Divider>
                        <Row v-if="contactArr.length">
                            <Col :key="index" span="24" v-for="(contact, index) in contactArr">
                                <Card>
                                    <p slot="title">Contact {{index+1}}
                                        <Icon style="float: right" type="md-close" @click.stop="removeContact(index)"></Icon>
                                        <Icon style="float: right;margin-right: 5px" type="md-create" @click.stop="onEditContact(contact, index)"></Icon></p>
                                    <Row>
                                        <Col span="10">Role</Col>
                                        <Col span="14">{{contact.role == 1 ? 'Marketing' : 'Dispatch'}}</Col>
                                        <Col span="10">Name</Col>
                                        <Col span="14">{{contact.name}}</Col>
                                        <Col span="10">Mobile</Col>
                                        <Col span="14">{{contact.mobile}}</Col>
                                        <Col span="10">Email</Col>
                                        <Col span="14">{{contact.email}}</Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                        <Row v-else>No Contact added yet</Row>
                        <!-- ------x-------x-------x-------x-------x--------x-------- -->
                      <!-- -------------------- Routes section ------------------- -->
                      <template v-if="companyForm.userType === Constants.companyType.transporter">
                        <Divider></Divider>
                        <Row><h3>Routes</h3></Row>
                        <Divider></Divider>
                        <FormItem prop="routes">
                          <template v-for="(i, index) in numOfRoutes">
                            <AutoComplete v-model="routes_fromCity[index]" style="width: 45%;margin:0 10px 5px 0"
                                          @on-search="handleCitySearch" @on-focus="routeCityFilter='%%'" placement="top">
                              <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                      :key="index" :value="cityObj.city">
                                <div class="ivu-select-item-div">{{cityObj.city}}</div>
                              </Option>
                            </AutoComplete>
                            <AutoComplete v-model="routes_toCity[index]" style="width: 45%;margin:0 5px 5px 0"
                                          @on-search="handleCitySearch" @on-focus="routeCityFilter='%%'" placement="top">
                              <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                      :key="index" :value="cityObj.city">
                                <div class="ivu-select-item-div">{{cityObj.city}}</div>
                              </Option>
                            </AutoComplete>
                            <Icon type="md-add-circle" size="22" v-if="index===0" @click="numOfRoutes++"/>
                          </template>
                        </FormItem>
                      </template>
                      <!-- ------x-------x-------x-------x-------x--------x-------- -->
                        <FormItem style="text-align: right;margin-top: 5px">
                            <Button :loading="update_loader" @click="handleSubmit('companyForm')" type="primary">Update
                            </Button>
                            <Button @click="handleReset('companyForm')" style="margin-left: 8px" type="error">Reset
                            </Button>
                        </FormItem>

                    </Card>
                </Form>
            </Col>
        </Row>
    </Drawer>

    <Drawer :mask-closable="false" @on-close="handleReset('addressForm')" title="Add Address"
            v-model="addAddressDrawer" width="620">
        <Row>
            <Col span="24">
                <Form :model="addressForm" :rules="addressRuleValidate" label-position="top" ref="addressForm">
                    <Row :gutter="32">
                        <Col span="12">
                            <FormItem label="Address 1" prop="add1">
                                <Input placeholder="Enter your Address" v-model="addressForm.add1"></Input>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="Address 2" prop="add2">
                                <Input placeholder="Enter your Address" v-model="addressForm.add2"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="32">
                        <Col span="12">
                            <FormItem label="City" prop="city" v-if="addAddressDrawer">
                                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}">
                                    <template slot-scope="{ result: { loading, error, data } }">
                                        <div v-if="loading"> Loading...</div>
                                        <div v-else-if="error"> Error Occured. {{error}}</div>
                                        <div v-else-if="data">
                                            <AutoComplete placeholder="Search City"
                                                          v-model="addressForm.city">
                                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data.city">
                                                    <div @click="addressForm.state=cityObj.state;selectedCityId=cityObj.id">{{cityObj.city}}</div>
                                                </Option>
                                            </AutoComplete>
                                        </div>
                                        <div v-else>
                                            There are no City Available yet.
                                        </div>
                                    </template>
                                </ApolloQuery>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="State" prop="state" v-if="addAddressDrawer">
                                <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}">
                                    <template slot-scope="{ result: { loading, error, data } }">
                                        <div v-if="loading"> Loading...</div>
                                        <div v-else-if="error"> Error Occured. {{error}}</div>
                                        <div v-else-if="data">
                                            <AutoComplete placeholder="Search State"
                                                          v-model="addressForm.state">
                                                <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data.territories">
                                                    {{stateObj.state}}
                                                </Option>
                                            </AutoComplete>
                                        </div>
                                        <div v-else>
                                            There are no State Available yet.
                                        </div>
                                    </template>
                                </ApolloQuery>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="32">
                        <Col span="12">
                            <FormItem label="Area" prop="area">
                                <Select v-model="addressForm.area" filterable>
                                    <Option v-for="(area,index) in areaArr" :value="area.area"
                                            :label="area.area" :key="index">
                                    </Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <FormItem label="PIN" prop="pincode">
                                <Input type="number" placeholder="Enter your PIN" v-model="addressForm.pincode"></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
        <Button @click="handleAddAddress()" color="primary">Add</Button>
    </Drawer>
    <Drawer :mask-closable="false" @on-close="handleReset('contactForm')" title="Add Contact"
            v-model="addContactDrawer" width="620">
        <Row>
            <Col span="24">
                <Form :model="contactForm" :rules="contactRuleValidate" label-position="top" ref="contactForm">
                    <FormItem label="Type" prop="type">
                        <RadioGroup v-model="contactForm.role">
                            <Radio label="1"><span>Marketing</span></Radio>
                            <Radio label="2"><span>Dispatch</span></Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="Contact Name" prop="name">
                        <Input :maxlength="30" v-model="contactForm.name"/>
                    </FormItem>
                    <FormItem label="Mobile Number" prop="mobile">
                        <Input type="number" v-model="contactForm.mobile"/>
                    </FormItem>
                    <FormItem label="Email" prop="email">
                        <Input v-model="contactForm.email"/>
                    </FormItem>
                </Form>
            </Col>
        </Row>
        <Button @click="handleAddContact()" color="primary">Add</Button>
    </Drawer>
    <Drawer :mask-closable="false" @on-close="handleReset('companyUserForm')" title="Add Company User"
            v-model="addCompanyUserDrawer" width="620">
        <Row>
            <Col span="24">
                <Form :model="companyUserForm" :rules="companyUserRuleValidate" label-position="top" ref="companyUserForm">
<!--                    <FormItem label="Type" prop="type">-->
<!--                        <RadioGroup v-model="companyUserForm.role">-->
<!--                            <Radio label="1"><span>Marketing</span></Radio>-->
<!--                            <Radio label="2"><span>Dispatch</span></Radio>-->
<!--                        </RadioGroup>-->
<!--                    </FormItem>-->
                    <FormItem label="User Name" prop="name">
                        <Input :maxlength="30" v-model="companyUserForm.name"/>
                    </FormItem>
                    <FormItem label="Mobile Number" prop="mobile">
                        <Input type="number" v-model="companyUserForm.mobile"/>
                    </FormItem>
                    <FormItem label="Email" prop="email">
                        <Input v-model="companyUserForm.email"/>
                    </FormItem>
                </Form>
            </Col>
        </Row>
        <Button @click="handleAddCompanyUser()" color="primary">Add</Button>
    </Drawer>

</div>
</template>

<script>
    import ValidationRules from '../Constants/ValidationRules'
    import { GET_COMPANY_TYPE } from '../graphql/queries/companies'
    import { ADD_CONTACT, ADD_CONTACT_TO_ADDRESSBOOK, ADD_COMPANY_USER } from '../graphql/mutations/contacts'
    import { UPDATE_COMPANY, UPDATE_ADDRESSBOOK_COMPANY, DELETE_ADDRESSBOOK_CONTACTS } from '../graphql/mutations/companies'
    import {GET_ALL_CITIES, SEARCH_CITY2, SEARCH_STATE} from '../graphql/queries/territories'
    import {GET_AREAS_BY_CITY} from '../graphql/queries/area'
    import {GET_COMPANY_USER_BY_MOBILE, GET_CONTACTS_AND_USERS} from '../graphql/queries/contacts'
    import {Constants, generateUUID} from "../Constants/Constant";
    import {getAddressString} from "./ExcelFormattedOrders/RendererFunctions";
    export default {
        apollo: {
            area: {
                query: GET_AREAS_BY_CITY,
                variables() {
                    return {
                        cityId: this.selectedCityId,
                    }
                },
                result({data, loading}) {
                    if (!loading) {
                        this.areaArr = data.area;
                    }
                }
            },
            city: {
              query: SEARCH_CITY2,
              variables() { return { cityFilter: this.routeCityFilter }},
              result ({ data, loading }) {
                if (!loading) { this.cityArr = data.city }
              }
            },
        },
        name: "EditCompanyDrawer",
        data: function(){
         let self = this
          return{
              query_GET_COMPANY_TYPE: GET_COMPANY_TYPE,
              query_SEARCH_CITY: SEARCH_CITY2,
              query_SEARCH_STATE: SEARCH_STATE,
              mutation_ADD_CONTACT: ADD_CONTACT,
              mutation_ADD_CONTACT_TO_ADDRESSBOOK: ADD_CONTACT_TO_ADDRESSBOOK,
              Constants: Constants,
              companyForm: {
                  userType: '',
                  name: '',
                  email: '',
                  mobile: '',
                  companyName: '',
                  registeredMobile: '',
                  registeredEmail: '',
                  gstin: '',
                  id: '',
                  routes: [],
                  isApproved: true
              },
              companyRuleValidate: {
                  userType: ValidationRules.userType, name: ValidationRules.name,
                  email: ValidationRules.email, mobile: ValidationRules.mobile,
                  gstin: ValidationRules.gstin
              },
              addAddressDrawer: false,
              addressForm: {
                  add1: '',
                  add2: '',
                  area: '',
                  pincode: null,
                  city: null,
                  state: null
              },
              addressRuleValidate: {
                  add1: ValidationRules.add2, area: ValidationRules.area,
                  city: ValidationRules.city, state: ValidationRules.state
              },
              addressArr: [],
              addContactDrawer: false,
              contactForm: {
                  role: '1',
                  name: '',
                  mobile: '',
                  email: ''
              },
              contactRuleValidate: {
                  name: [{ required: true, message: 'Enter name', trigger: 'blur' }],
                  email: [{ type: 'email', message: 'Incorrect email format', trigger: 'change' }],
                  mobile: [{ validator: self.validateMobile, trigger: 'change' }]
              },
              contactArr: [],
              companyType_skip: true,
              selectedCityId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
              areaArr: [],
              update_loader: false,
              editIndex: null,
              companyUsers: [],
              existingCompanyUsers: [],
              addCompanyUserDrawer: false,
              companyUserForm: {
                role: '1',
                name: '',
                mobile: '',
                email: ''
              },
              companyUserRuleValidate: {
                name: [{ required: true, message: 'Enter name', trigger: 'blur' }],
                email: [{ type: 'email', message: 'Incorrect email format', trigger: 'change' }],
                mobile: [{ validator: self.validateMobile, trigger: 'change' }]
              },
              getAddressString: getAddressString,
              cityArr: [],
              numOfRoutes: 1,
              routes_fromCity: {},
              routes_toCity: {},
              routeCityFilter: '%%',
          }
        },
        methods:{
            handleReset (name) {
                this.$refs[name].resetFields()
                this.editIndex = null
                if (name == 'companyForm') {
                    this.addressArr = []
                    this.contactArr = []
                    this.companyUsers = []
                    this.numOfRoutes = 1;
                    this.routes_fromCity = {};
                    this.routes_toCity = {};
                }
            },
            handleCitySearch: _.debounce(function(val){
              this.routeCityFilter = '%' + val + '%'
            }, 500),
            setCompanyForm(val){
              this.companyForm.userType = val.type
              this.companyForm.name = val.name
              this.companyForm.mobile = Number(val.mobile)
              this.companyForm.email = val.email
              this.companyForm.gstin = val.gstin
              this.companyForm.isApproved = val.isApproved
              this.companyForm.id = val.id
              this.addressArr = JSON.parse(JSON.stringify(val.address))
              this.numOfRoutes = val.routes?.length || 1;
              for(let i=0; i<(val.routes?.length||0); i++){
                this.routes_fromCity[i] = val.routes[i].fromCity
                this.routes_toCity[i] = val.routes[i].toCity
              }
              this.fetchContactsAndUsers(val.id)
            },
            removeAddress(index){
              this.addressArr.splice(index, 1)
            },
            removeContact(index){
              this.contactArr.splice(index, 1)
            },
            removeCompanyUser(index){
              this.companyUsers.splice(index, 1)
            },
            async onEditAddress(address, index){
                this.addressForm.add1 = address.add1
                this.addressForm.add2 = address.add2
                this.addressForm.pincode = address.pincode
                this.addressForm.state = address.state
                this.addressForm.city = address.city
                this.addressForm.area = address.area
                this.editIndex = index
                this.addAddressDrawer = true

           /* ----- Retrieve all cities for retrieving areas by cityId and to autofill area ----- */
              let response = await this.$apollo.query({
                query: GET_ALL_CITIES,
                fetchPolicy: 'network-only',
              })
              if(response.data.city.length){
                let matchedObj = response.data.city.find(({city}) => city === address.city);
                this.selectedCityId = matchedObj ? matchedObj.id : this.selectedCityId;
              }
           /* ----------------x---------------x---------------x-----------------x----------------- */
            },
            onEditContact(contact, index){
                this.contactForm.role = contact.role.toString()
                this.contactForm.name = contact.name
                this.contactForm.email = contact.email
                this.contactForm.mobile = parseInt(contact.mobile)
                this.editIndex = index
                this.addContactDrawer = true
            },
            onEditCompanyUser(user, index){
                this.companyUserForm.role = user.role.toString()
                this.companyUserForm.name = user.name
                this.companyUserForm.email = user.email
                this.companyUserForm.mobile = parseInt(user.mobile)
                this.editIndex = index
                this.addCompanyUserDrawer = true
            },
            async handleSubmit (name) {

              if(this.companyUsers.length){
                let arr = this.companyUsers.map((usr) => usr.mobile.toString());
                //First find any duplicates ...
                let uniqueDuplicates = [...new Set(arr.filter((item, index) => arr.indexOf(item) != index))];
                if(uniqueDuplicates.length){
                  this.$Message.info({content: 'Company Users - Duplicate Numbers found ! <br>'+uniqueDuplicates.join(",  ") ,
                    duration: 10, closable: true});
                  return;
                }
                //Second find any mobile already in db ...
                let toRemove = this.existingCompanyUsers.map((usr) => usr.mobile.toString());
                arr = arr.filter( ( el ) => !toRemove.includes( el ) )               //Not to check mobile of existing users
                let response = await this.$apollo.query({
                  query: GET_COMPANY_USER_BY_MOBILE,
                  variables: {
                    mobileArr: arr,
                  }
                })
                if(response.data.companyUsers.length){
                  uniqueDuplicates = response.data.companyUsers.map((usr) => usr.mobile);
                  this.$Message.info({content: 'Company Users - Mobile already exists ! <br>'+uniqueDuplicates.join(",  ") ,
                    duration: 10, closable: true});
                  return ;
                }

              }


                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.addressArr.length) {
                            this.updateCompany()
                            this.updateCompanyToAddressBook()
                        } else {
                            this.$Message.error('Please enter atleast one address!')
                        }
                    } else {
                        this.$Message.error('Check Details!')
                    }
                })
            },
            async updateCompany(){
                let self = this
                //update Company query
                //Delete all contacts by companyId
                //Insert all conatcts from contactArr
                let routes = []
                for(let i=0; i<this.numOfRoutes; i++){
                  if(this.routes_fromCity[i] && this.routes_toCity[i]) routes.push({fromCity: this.routes_fromCity[i], toCity: this.routes_toCity[i]})
                }
                this.companyForm.routes = this.companyForm.userType === Constants.companyType.transporter? routes : null
                this.update_loader = true
                let response = await this.$apollo.mutate({
                    mutation: UPDATE_COMPANY,
                    variables: {
                        id: this.companyForm.id,
                        name: this.companyForm.name,
                        type: this.companyForm.userType,
                        mobile: this.companyForm.mobile.toString(),
                        email: this.companyForm.email,
                        gstin: this.companyForm.gstin?.toString()||'',
                        address: this.addressArr,
                        routes: this.companyForm.routes,
                        isApproved: this.companyForm.isApproved,
                        isRejected: !this.companyForm.isApproved,
                    }
                })
                if(response.data){
                    this.update_loader = false
                    this.$parent.updateCompanyDrawer = false
                    this.numOfRoutes = 1;                     //Reset
                    this.routes_fromCity = {};                //Reset
                    this.routes_toCity = {};                  //Reset
                    if(this.companyUsers.length){this.addCompanyUsers(this.companyForm.id)}
                    this.contactArr.forEach(function (curnt, index) {
                        self.addContact(curnt, self.companyForm.id)
                    })
                }
            },
            async addCompanyUsers (clientId) {
              this.companyUsers.forEach((user) => {
                user.id = generateUUID();
                user.clientid = clientId;
                user.mobile = user.mobile;
                user.role = Number(user.role);
                if(user.__typename) delete user.__typename;
              });
              let object = [...this.companyUsers];

              let response = await this.$apollo.mutate({
                mutation: ADD_COMPANY_USER,
                variables: {
                  object: object
                }
              })

            },
            async addContact (contactObj, clientId) {
                let self = this
                let response = await this.$apollo.mutate({
                    mutation: ADD_CONTACT,
                    variables: {
                        id: this.generateUUID(),
                        name: contactObj.name,
                        mobile: Number(contactObj.mobile),
                        email: contactObj.email,
                        role: parseInt(contactObj.role),
                        clientid: clientId
                    }
                })
                if (response.data.insert_contacts.returning[0].id) {
                }
            },
            async updateCompanyToAddressBook(){
                //update addressBookedCompany by parentCompanyId (if any, check first)
                let self = this
                let response = await this.$apollo.mutate({
                    mutation: UPDATE_ADDRESSBOOK_COMPANY,
                    variables: {
                        parentCompanyId: this.companyForm.id,
                        name: this.companyForm.name,
                        type: this.companyForm.userType,
                        mobile: this.companyForm.mobile.toString(),
                        email: this.companyForm.email,
                        gstin: this.companyForm.gstin?.toString()||'',
                        address: this.addressArr,
                        isApproved: this.companyForm.isApproved,
                    }
                })
                if(response.data.update_addressbookedcompany.returning.length &&
                    response.data.update_addressbookedcompany.returning[0].id){
                    this.deleteAddressBookContacts(response.data.update_addressbookedcompany.returning[0].id)
                }
            },
            async deleteAddressBookContacts(clientId){
                let self = this
                let response = await this.$apollo.mutate({
                    mutation: DELETE_ADDRESSBOOK_CONTACTS,
                    variables: {clientid: clientId}
                })
                if(response.data){
                    this.contactArr.forEach(function (curnt, index) {
                        self.addContactToAddressBook(curnt, clientId)
                    })
                }
            },
            async addContactToAddressBook (contactObj, clientId) {
                let self = this
                let response = await this.$apollo.mutate({
                    mutation: ADD_CONTACT_TO_ADDRESSBOOK,
                    variables: {
                        id: this.generateUUID(),
                        name: contactObj.name,
                        mobile: contactObj.mobile,
                        email: contactObj.email,
                        role: parseInt(contactObj.role),
                        clientid: clientId
                    }
                })
                if (response.data.insert_addressbookedcontacts.returning[0].id) {

                }
            },
            handleAddAddress () {
                this.$refs['addressForm'].validate((valid) => {
                    if (valid) {
                        let addressObj = Object.assign({}, this.addressForm)
            /* --------- When edit/update address ----------- */
                        if(this.editIndex !== null){
                            this.addressArr.splice(this.editIndex, 1)
                        }
            /* ----------x--------------x-----------x--------- */
                        this.addressArr.push(addressObj)
                        this.handleReset('addressForm')
                        this.addAddressDrawer = false
                    } else {
                        this.$Message.error('Fail to add Address')
                    }
                })
            },
            handleAddContact () {
                this.$refs['contactForm'].validate((valid) => {
                    if (valid) {
                        let contactObj = Object.assign({}, this.contactForm)
                    /* --------- When edit/update address ----------- */
                        if(this.editIndex !== null){
                            this.contactArr.splice(this.editIndex, 1)
                        }
                    /* ----------x--------------x-----------x--------- */
                        this.contactArr.push(contactObj)
                        this.handleReset('contactForm')
                        this.addContactDrawer = false
                    } else {
                        this.$Message.error('Fail to add Contact')
                    }
                })
            },
            handleAddCompanyUser () {
                this.$refs['companyUserForm'].validate((valid) => {
                    if (valid) {
                        let companyUserObj = Object.assign({}, this.companyUserForm)
                    /* --------- When edit/update user ----------- */
                        if(this.editIndex !== null){
                            this.companyUsers.splice(this.editIndex, 1)
                        }
                    /* ----------x--------------x-----------x--------- */
                        this.companyUsers.push(companyUserObj)
                        this.handleReset('companyUserForm')
                        this.addCompanyUserDrawer = false
                    } else {
                        this.$Message.error('Fail to add user')
                    }
                })
            },
            validateMobile (rule, value, callback) {
                if (value && value.toString().length !== 10) {
                    callback(new Error('Length Must be equal to 10 digit'))
                } else {
                    callback()
                }
            },
            async fetchContactsAndUsers(companyId){
                let response = await this.$apollo.query({
                    query: GET_CONTACTS_AND_USERS,
                    fetchPolicy:'network-only',
                    variables: {
                        partyId: companyId
                    }
                })
                if(response.data){
                    this.contactArr = JSON.parse(JSON.stringify(response.data.contacts))
                    this.companyUsers = JSON.parse(JSON.stringify(response.data.users))
                    this.existingCompanyUsers = JSON.parse(JSON.stringify(response.data.users))
                }
            },
            generateUUID () {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
                    return v.toString(16)
                })
            },
        },
        computed: {
            cityFilter () {
                return '%' + this.addressForm.city + '%'
            }, stateFilter () {
                return '%' + this.addressForm.state + '%'
            }
        },

    }
</script>

<style scoped>

</style>
